import { Link } from "react-router";
import { Banner } from "../../components/Banner";
import { ScreenHeader } from "../../components/ScreenHeader";
import { useSession } from "../../lib/session";

/** The celebration screen after clearing a gate. The server has already recorded the clearance. */
export function DoneScreen({
  kicker,
  title,
  sub,
  next,
}: {
  kicker: string;
  title: string;
  sub: string;
  next?: { to: string; label: string };
}) {
  const { user } = useSession();
  return (
    <div>
      <ScreenHeader kicker={kicker} title={title} sub={sub} />
      <Banner tone="good">✓ Recorded against {user?.email}.</Banner>
      <div className="flex flex-wrap gap-2.5">
        {next ? (
          <Link
            to={next.to}
            className="inline-flex min-h-11 items-center rounded-[var(--radius-control)] bg-accent px-[22px] text-[14.5px] font-bold text-on-accent"
          >
            {next.label} →
          </Link>
        ) : null}
        <Link
          to="/hub"
          className="inline-flex min-h-11 items-center rounded-[var(--radius-control)] border-[1.5px] border-border px-[22px] text-[14.5px] font-bold text-accent"
        >
          Back to my steps
        </Link>
      </div>
    </div>
  );
}
